import React, { useEffect, useState } from 'react';
interface PopData {
  name: string;
  location: string;
  action: string;
  time: string;
}
const popData: PopData[] = [{
  name: 'Jessica M.',
  location: 'Austin, TX',
  action: 'just purchased the B.A.B.Y. 365 Protocol',
  time: '2 minutes ago'
}, {
  name: 'Brandon K.',
  location: 'Denver, CO',
  action: 'added the full bundle to cart',
  time: '5 minutes ago'
}, {
  name: 'Ana L.',
  location: 'Houston, TX',
  action: 'just bought Golden Nights',
  time: '3 minutes ago'
}, {
  name: 'Emily W.',
  location: 'Nashville, TN',
  action: 'just purchased the B.A.B.Y. 365 Protocol',
  time: '1 minute ago'
}, {
  name: 'Michael R.',
  location: 'Phoenix, AZ',
  action: 'added the full bundle to cart',
  time: '7 minutes ago'
}, {
  name: 'Gabriela S.',
  location: 'Miami, FL',
  action: 'just bought the complete protocol',
  time: '4 minutes ago'
}, {
  name: 'Ryan T.',
  location: 'Charlotte, NC',
  action: 'just purchased the B.A.B.Y. 365 Protocol',
  time: '6 minutes ago'
}, {
  name: 'Sarah H.',
  location: 'San Diego, CA',
  action: 'added Little Genius to cart',
  time: '2 minutes ago'
}];
export function PopNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [popIndex, setPopIndex] = useState(0);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    // First pop after 20 seconds
    const firstTimeout = setTimeout(() => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Then exactly every 20 seconds
      interval = setInterval(() => {
        setPopIndex(prev => prev + 1);
        setIsVisible(true);
        setTimeout(() => {
          setIsVisible(false);
        }, 4000);
      }, 20000);
    }, 20000);
    return () => {
      clearTimeout(firstTimeout);
      if (interval) clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  const currentPop = popData[popIndex % popData.length];
  return <div className="fixed bottom-5 left-5 z-[9999] bg-white rounded-xl p-3.5 shadow-2xl max-w-[300px] w-[90%] border-l-4 border-[#B76E79] animate-slide-in font-sans" data-id="element-218">
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2.5 text-xl text-[#6B4C3B] bg-transparent border-none cursor-pointer" data-id="element-219">
        ×
      </button>
      <span className="text-2xl mr-2.5 float-left" data-id="element-220">🛒</span>
      <div className="text-[13px] text-[#3D2B1F] leading-relaxed" data-id="element-221">
        <strong className="text-[#B76E79] block text-sm" data-id="element-222">
          {currentPop.name} from {currentPop.location}
        </strong>
        <span data-id="element-223">{currentPop.action}</span>
        <div className="text-[11px] text-gray-400 mt-1" data-id="element-224">{currentPop.time}</div>
      </div>
    </div>;
}